import React from "react";
import {AssistantNewChats} from '../assistantNew';
import {ModelType, ModelTypeID} from "../../api";
import {AuthCheck} from "../../layout/enaea/AuthCheck";

export const NewAiHeadTeacherChats = () => {
    return <AuthCheck>
        <AssistantNewChats modelType={ModelType.CUSTOMER_SERVICE_ASSISTANT} showLogin={true}
                           modelTypeId={ModelTypeID.CUSTOMER_SERVICE_ASSISTANT}/>
    </AuthCheck>;
};

